import React, { Component } from 'react'
import PropTypes from 'prop-types'

const uuid = require('uuid/v4')

class ResizableCellProp extends Component {
  state = {
    cellId: '',
    columnId: '',
  }
  mainRef = React.createRef()

  componentDidMount() {
    const cellId = uuid()

    this.setState({
      cellId,
      columnId: this.props.subscribe(cellId, () => (this.mainRef.current ? this.mainRef.current.offsetWidth : 0)),
    })
  }

  componentWillUnmount() {
    this.props.unsubscribe(this.state.cellId)
  }

  render() {
    const { children, className } = this.props
    const { columnId } = this.state

    return (
      <div
        ref={this.mainRef}
        style={{
          display: 'flex',
        }}
      >
        {React.cloneElement(children, {
          width: `var(--${columnId})`,
          className,
        })}
      </div>
    )
  }
}

ResizableCellProp.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, () => null]),
  subscribe: PropTypes.func,
  unsubscribe: PropTypes.func,
}

ResizableCellProp.defaultProps = {
  className: null,
  subscribe: () => {},
  unsubscribe: () => {},
}

export default ResizableCellProp
